import { Enrollment, EnrollmentDto } from './Enrollment';
import { utilities } from 'utils/utilities';

export interface ConsultationEnrollmentDto extends EnrollmentDto {
  consultationType: string;
  consultationAddress?: string;
  videoProvider?: string;
}

/**
 * Enrollment pending confirmation of a consultation appointment.
 * Created by ConsultationNodeHandler (Phase 1).
 */
export class ConsultationEnrollment extends Enrollment {
  /** "Physical" or "Online" */
  consultationType: string;
  /** Physical consultations only. */
  consultationAddress?: string;
  /** Online consultations only. E.g. "GoogleMeet", "Zoom". */
  videoProvider?: string;

  readonly type: 'ConsultationEnrollment' = 'ConsultationEnrollment';

  constructor(
    id: string,
    consultationType: string,
    consultationAddress?: string,
    videoProvider?: string
  ) {
    super(id);
    this.consultationType = consultationType;
    this.consultationAddress = consultationAddress;
    this.videoProvider = videoProvider;
  }

  toDto(): ConsultationEnrollmentDto {
    return {
      consultationType: this.consultationType,
      consultationAddress: this.consultationAddress,
      videoProvider: this.videoProvider,
      id: this.id,
      enrollmentType: this.type,
      dtoType: 'Models.Api.Dtos.ConsultationEnrollmentDto',
      nodeInstanceId: this.nodeInstanceId,
      requiredSubmissionType: this.requiredSubmissionType,
      status: this.status,
      satisfiedAt: this.satisfiedAt,
    };
  }

  static fromDto(dto?: Partial<ConsultationEnrollmentDto> | ConsultationEnrollment | any): ConsultationEnrollment {
    if (!dto) {
      return new ConsultationEnrollment(utilities.DEFAULT_GUID, '');
    }

    if (dto instanceof ConsultationEnrollment) {
      return dto;
    }

    const id = dto.id ?? utilities.DEFAULT_GUID;
    const consultationType = dto.consultationType ?? '';
    return new ConsultationEnrollment(id, consultationType, dto.consultationAddress, dto.videoProvider);
  }
}

// Self-register to avoid Enrollment needing a hard import
Enrollment.register('ConsultationEnrollment', (d?: any) => ConsultationEnrollment.fromDto(d));
